import React from "react";

import { Box, Button, Modal, Stack } from "@mui/material";
import { PickerHeader } from "components/Prompts/Deal-content-picker/components/PickerHeader";
import { ISelectDealFolderModal } from "store/types/modals";

import { DealSelect } from "./components/DealSelect";
import { FolderSelect } from "./components/FolderSelect";
import { useSelectDealFolderHook } from "./hooks/useSelectDealFolder";

const DIVIDER = "1px solid #E5E8EF";
const SHADOW = "0px 10px 10px -5px rgba(18, 18, 23, 0.04), 0px 20px 25px -5px rgba(18, 18, 23, 0.10)";

export const SelectDealFolderModal: React.FC<ISelectDealFolderModal> = ({
  isOpen,
  preselectedDeal,
  title,
  onSubmit,
  onClose,
  isGeneralDocument
}) => {
  const {
    deal,
    setDeal,
    step,
    setStep,
    selectedFolder,
    setSelectedFolder,
    hasNewFolder,
    loading,
    folders,
    handleOutsideUnselect,
    onCreateNewFolder,
    onSelectHandle,
    onCloseModal,
    isSelectDisabled
  } = useSelectDealFolderHook({ onSubmit, preselectedDeal, onClose, isGeneralDocument });

  const isStepSelectDeal = step === "select-deal";
  const isStepSelectFolder = step === "select-folder";

  return (
    <Modal open={isOpen} onClose={onCloseModal}>
      <Box
        sx={{
          width: "100%",
          maxWidth: 1100,
          maxHeight: "calc(100vh - 48px)",
          background: "#fff",
          borderRadius: "12px",
          border: DIVIDER,
          boxShadow: SHADOW,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          outline: "none",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)"
        }}
        onClick={handleOutsideUnselect}
      >
        <PickerHeader title={title} onClose={onCloseModal} />

        {/* Content */}
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          {!preselectedDeal && isStepSelectDeal && <DealSelect deal={deal} setDeal={setDeal} />}
          {isStepSelectFolder && (
            <FolderSelect
              deal={deal}
              folders={folders}
              loading={loading}
              selectedFolder={selectedFolder}
              onCreateNewFolder={onCreateNewFolder}
              onStepBack={() => setStep("select-deal")}
              hasNewFolder={hasNewFolder}
              setSelectedFolder={setSelectedFolder}
              isGeneralDocument={isGeneralDocument}
            />
          )}
        </Box>

        {/* Footer */}
        <Stack direction="row" alignItems="center" justifyContent="flex-end" gap="10px" sx={{ px: "20px", py: "14px" }}>
          <Button variant="outlined" onClick={onCloseModal}>
            Cancel
          </Button>
          <Button
            disabled={isSelectDisabled}
            variant="contained"
            onClick={onSelectHandle}
            data-move-document-submit
          >
            Select
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
